import i18n from '../i18n';
import { getRBPStringId } from '../page/main/main-page-states';
import { tunnelStatusStore } from '../page/main/tunnel-status-state';

/**
 * 读取全局隧道状态（不重复发起 `check-permission`）。
 * 须在 `observer` 组件内调用，以便随 `tunnelStatusStore` 更新重渲染。
 * @returns tunnelState 是否可用；tunnelStateText 不可用时的展示文案
 */
export function useCurrentRestaurantCheck() {
    const stringId = getRBPStringId();
    const { passStatus, tunnelFailLine, dbVersionGateMessage } = tunnelStatusStore;

    const tunnelState = tunnelStatusStore.isAvailableForRestaurant(stringId);

    let tunnelStateText = '';
    if (!stringId) {
        tunnelStateText = i18n.t('business_analysis_page_none_restaurant');
    } else if (tunnelStatusStore.currentStringId !== stringId || passStatus === 0) {
        tunnelStateText = i18n.t('general_text_checking_tunnel_service');
    } else if (passStatus === -3) {
        tunnelStateText = dbVersionGateMessage;
    } else if (passStatus === -1) {
        tunnelStateText = tunnelFailLine || i18n.t('business_analysis_page_msg_no_database_config');
    } else if (passStatus === -2) {
        tunnelStateText = i18n.t('business_analysis_page_none_restaurant');
    }

    return { tunnelState, tunnelStateText };
}
